import { IFreeBetSetting } from '../models/settings/freeBetSetting.interface';
import { ActivatedRoute } from '@angular/router';
import { SettingsProviderService } from './providers/settings.provider.service';
import { DeployParams } from '../deployParams';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ModelMapperService } from './util/model.mapper.service';
import { UserService } from './user.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class FreeBetService {

  public playerFreeBetSettings: IFreeBetSetting;

  constructor(private route: ActivatedRoute, private settingsProvider: SettingsProviderService, private modelMapper: ModelMapperService, private userService: UserService) {

    if (environment.localDeploy) {
      if (this.userService.user.userSBToken != null && this.userService.user.userSBToken && this.userService.user.userSBToken !== '') {
        this.setFreeBetSettings(+this.userService.user.userName);
      }
      this.userService.userLoggedInOut$.subscribe(x => {
        if (true) {
          this.setFreeBetSettings(+this.userService.user.userName);
        }
      });
    }
    else {
      this.route.queryParams.subscribe(params => {
        this.paramsChangedSetFreebetSettings(params);
      });
    }
  }



  paramsChangedSetFreebetSettings(params: any): any {
    const playerId = params.username ? params.username : null;

    if (playerId == null) {
      return;
    }
    this.setFreeBetSettings(playerId);
  }

  setFreeBetSettings(playerId: number): void {
    const playerFBS = sessionStorage.getItem('freeBetSettings' + playerId);
    this.playerFreeBetSettings = playerFBS ? JSON.parse(playerFBS) : null;

    if (!this.playerFreeBetSettings) {
      if (playerId) {
        this.settingsProvider.getFreeBetSettings(playerId).pipe(
          map(fb => {
            if (!fb) {
              return null;
            }
            return this.modelMapper.mapFreeBetSetting(fb);
          })
        ).subscribe(freeBet => {
          this.playerFreeBetSettings = freeBet;
          sessionStorage.setItem('freeBetSettings' + playerId, JSON.stringify(this.playerFreeBetSettings));
        });
      }
    } else {
      this.playerFreeBetSettings.toDate = new Date(this.playerFreeBetSettings.toDate);
      this.playerFreeBetSettings.fromDate = new Date(this.playerFreeBetSettings.fromDate);
      this.playerFreeBetSettings.updatedOn = new Date(this.playerFreeBetSettings.updatedOn);
    }

  }
}
